import { render, staticRenderFns } from "./AddInboundPanel.vue?vue&type=template&id=19c8b3c8&scoped=true"
import script from "./AddInboundPanel.vue?vue&type=script&lang=js"
export * from "./AddInboundPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c8b3c8",
  null
  
)

export default component.exports